import React from "react";
import style from "./style.module.scss";

export default function Results(props) {
  const { rows, className, ...rest } = props;
  return (
    <div className={`${style.results} ${className || ""}`} {...rest}>
      {rows.map(__row => (
        <div data-type={__row.type} className={style.row}>
          <span>{__row.label}</span>
          <span>{__row.value}</span>
        </div>
      ))}
    </div>
  );
}
